/**
 * Small helpers for the hand-written guards that sit on every boundary
 * (bootstrap, bridge messages, API responses).
 */

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.length > 0;
}

export function isNullableString(value: unknown): value is string | null {
  return typeof value === "string" || value === null;
}

export function isNull(value: unknown): value is null {
  return value === null;
}
